/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 21L3 15.375M3 21L8.625 21M3 21L21 3M21 3L15.375 3M21 3L21 8.625"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 3L3 8.625M3 3L8.625 3M3 3L21 21M21 21L15.375 21M21 21L21 15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="3"
				y="3"
				width="18"
				height="18"
				fill="currentColor"
			/>
			<path
				d="M3 21V15.375M3 21H8.625M3 21L21 3M21 3H15.375M21 3V8.625M3 3V8.625M3 3H8.625M3 3L21 21M21 21H15.375M21 21V15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21V15.375M3 21H8.625M3 21L21 3M21 3H15.375M21 3V8.625M3 3V8.625M3 3H8.625M3 3L21 21M21 21H15.375M21 21V15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 21V15.375M3 21H8.625M3 21L7 17M21 3H15.375M21 3V8.625M21 3L17 7M10 14L14 10M3 3V8.625M3 3H8.625M3 3L21 21M21 21H15.375M21 21V15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 21V15.375M3 21H8.625M3 21L21 3M21 3H15.375M21 3V8.625M3 3V8.625M3 3H8.625M3 3L21 21M21 21H15.375M21 21V15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21V15.375M3 21H8.625M3 21L21 3M21 3H15.375M21 3V8.625M3 3V8.625M3 3H8.625M3 3L21 21M21 21H15.375M21 21V15.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
